<template>
  <div class="count__wrap">
    <div class="count__date">距结束{{ countdown.days }}天</div>
    <div class="count__time">
      <span>{{ countdown.hours }}</span>
      <span>{{ countdown.minutes }}</span>
      <span>{{ countdown.seconds }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    endTime: {
      type: String | Number,
      default: ''
    }
  },

  data () {
    return {
      countdown: {},
      countdownTask: null
    }
  },

  created() {
    this.leftTime = this.endTime
    this.calculateCountDown()
  },

  beforeDestroy() {
    clearTimeout(this.countdownTask)
  },

  methods: {
    calculateCountDown () {
      if (this.leftTime > 0) {
        const leftTime = this.leftTime; //计算剩余的毫秒数
        const days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10); //计算剩余的天数
        const hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10); //计算剩余的小时
        const minutes = parseInt(leftTime / 1000 / 60 % 60, 10);//计算剩余的分钟
        const seconds = parseInt(leftTime / 1000 % 60, 10);//计算剩余的秒数
        this.countdown = {
          days,
          hours: hours > 9 ? hours : '0' + hours,
          minutes: minutes > 9 ? minutes : '0' + minutes,
          seconds: seconds > 9 ? seconds : '0' + seconds
        }
        this.countdownTask = setTimeout(() => {
            this.leftTime -= 1000
            this.calculateCountDown()
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/scss/function';

.count__wrap {
  position: absolute;
  top: 0;
  width: 100%;
  height: topx(88rem);
  background: url(~@/assets/525/image-countdown.png) no-repeat;
  background-size: cover;

  .count__date {
    position: absolute;
    top: topx(12rem);
    right: topx(50rem);
    color: #FF714F;
    font-size: topx(20rem);
    line-height: topx(24rem);
  }

  .count__time {
    position: absolute;
    top: topx(45rem);
    right: topx(34rem);
    color: #FF714F;
    font-size: topx(21rem);
    line-height: topx(27rem);

    span {
      margin-left: topx(20rem);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/show/activity/2021525/count-down.vue